import db from "../Db";

import { GetApiData } from "../Get/ApiData";
import { handleError } from "../Function";

var _ = require("lodash");

export async function CreateDuree(headers) {
  const _duree = await GetApiData("DUREE", headers);

  if (_duree.Message !== undefined) {
    return _duree;
  }

  var drops = [];
  _.forEach(_duree, (duree) => {
    drops.push({
      NUMDURE: duree.NUMDURE,
      LIBDURE: duree.LIBDURE.trim(),
      VALDURE: duree.VALDURE,
    });
  });

  return await db
    .open()
    .then(() => {
      return db.DUREE.bulkAdd(drops)
        .then(() => {
          return "";
        })
        .catch((err) => {
          return handleError(err);
        });
    })
    .catch((err) => {
      return handleError(err);
    });
}
